export default __webpack_public_path__ + "static/media/eyes.a7e06f63.svg";